import DropDownItemContainer from 'components/DropDownItemContainer';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const MapDropdown = ({ children, className = '', testId = TEST_ID }: Props) => (
    <DropDownItemContainer
        className={`${styles.dropdownItemContainer} ${className}`}
        testId={testId}>
        {children}
    </DropDownItemContainer>
);

export default MapDropdown;
